
<div class="popup-wrapper" (click)="hide()">
  <div class="popup-content" [style]="{ 'width': params.width, 'height': params.height }" (click)="stopPropagation($event)">
    <ng-content></ng-content>
  </div>
</div>